import React, { Suspense, lazy } from 'react';
import { Switch, Router,Route, Redirect } from 'react-router-dom';

import Nprogress from "@/components/Nprogress/index";
import { newPath } from '@/utils/index'

// new
import NewAmbassador from '@/pages2/ambassador/index'
import NewApply from '@/pages2/ambassador/apply'
import NewApplySuccess from '@/pages2/ambassador/success'
import Products from '@/pages2/products/index'
import Sub from '@/pages2/sub/index'
import Ecosystem from '@/pages2/sub/ecosystem'
import News from '@/pages2/news/index'
import NewsDetail from '@/pages2/news/detail'

import Airdrop from '@/pages2/airdrop/index'
import Stake from '@/pages2/stake/index'

import Snap from '@/pages2/snap/index'

// const Home = lazy(() => import('@/pages/home/index'));

// new
// const NewHome = lazy(() => import('@/pages2/home/index'));
import NewHome from '@/pages2/home/index'

const Routes = () => (
  <Suspense fallback={<Nprogress />}>
    <Switch>
      {/* <Route exact path='/' component={Home} /> */}
      {/* <Route exact path='/ambassador' component={Ambassador} /> */}
      {/* <Route exact path='/apply' component={Apply} /> */}
      {/* <Route exact path='/apply_success' component={ApplySuccess} /> */}
      {/* <Route exact path="/presale/:channelId?" component={Presale} />
      <Route exact path="/orders" component={Orders} />
      <Route exact path="/referrals" component={Referrals} /> */}
      {/* <Route exact path="/invite" component={Send} /> */}

      <Route exact path={`${newPath}/`} component={NewHome} />
      <Route exact path={`${newPath}/ambassador`} component={NewAmbassador} />
      <Route exact path={`${newPath}/apply`} component={NewApply} />
      <Route exact path={`${newPath}/apply_success`} component={NewApplySuccess} />
      <Route exact path={`${newPath}/dapp`} component={Products} />
      {/* <Route exact path={`${newPath}/sub`} component={Sub} /> */}
      <Route exact path={`${newPath}/ecosystem`} component={Ecosystem} />
      <Route exact path={`${newPath}/news`} component={News} />
      <Route exact path={`${newPath}/news_detail/:id`} component={NewsDetail} />

      <Route exact path={`/airdrop`} component={Airdrop} />
      <Route exact path={`/stake`} component={Stake} />

      <Route exact path={`/snap`} component={Snap} />

      <Redirect from="*" to={`${newPath}/`} />
    </Switch>
  </Suspense>
);

export default Routes;
